import { isAfter, isBefore } from 'date-fns';

import {
  CartPurchaseRewardPromotionalEvent,
  MarketPromotionalEvent,
  SpecialEditionPromotionalEvent,
  Sport,
} from '@sorare/core/src/__generated__/globalTypes';
import { isType } from '@sorare/core/src/lib/gql';

export const isMarketPromotion = (promotion: {
  __typename: string;
}): promotion is
  | MarketPromotionalEvent
  | SpecialEditionPromotionalEvent
  | CartPurchaseRewardPromotionalEvent => {
  return (
    isType(promotion, 'MarketPromotionalEvent') ||
    isType(promotion, 'SpecialEditionPromotionalEvent') ||
    isType(promotion, 'CartPurchaseRewardPromotionalEvent')
  );
};

const now = new Date();

const isPromoLive = ({
  startDate,
  endDate,
}: {
  startDate: Date;
  endDate: Date;
}) => isBefore(now, endDate) && isAfter(now, startDate);

export const filterLivePromos = <
  T extends { sport: Sport; startDate: Date; endDate: Date },
>(
  promos: T[],
  sport: Sport
) => {
  return promos.filter(isPromoLive).filter(promo => promo.sport === sport);
};
